import { render, staticRenderFns } from "./deliverySettings.vue?vue&type=template&id=2d3f6d78&scoped=true"
import script from "./deliverySettings.vue?vue&type=script&lang=js"
export * from "./deliverySettings.vue?vue&type=script&lang=js"
import style0 from "./deliverySettings.vue?vue&type=style&index=0&id=2d3f6d78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f6d78",
  null
  
)

export default component.exports